var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 380 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14621_14788)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 662,
    width: 312,
    height: 654,
    rx: 57,
    transform: "rotate(-180 353 662)",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5 123V108.5C79.5 106.291 81.2909 104.5 83.5 104.5H98C99.1046 104.5 100 105.395 100 106.5C100 107.605 99.1046 108.5 98 108.5H83.5V123C83.5 124.105 82.6046 125 81.5 125C80.3954 125 79.5 124.105 79.5 123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5 316L321.5 330.5C321.5 332.709 319.709 334.5 317.5 334.5L303 334.5C301.895 334.5 301 333.605 301 332.5C301 331.395 301.895 330.5 303 330.5L317.5 330.5L317.5 316C317.5 314.895 318.395 314 319.5 314C320.605 314 321.5 314.895 321.5 316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 104.5L317.5 104.5C319.709 104.5 321.5 106.291 321.5 108.5L321.5 123C321.5 124.105 320.605 125 319.5 125C318.395 125 317.5 124.105 317.5 123L317.5 108.5L303 108.5C301.895 108.5 301 107.605 301 106.5C301 105.395 301.895 104.5 303 104.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 334.5L84.5 334.5C82.2909 334.5 80.5 332.709 80.5 330.5L80.5 316C80.5 314.895 81.3954 314 82.5 314C83.6046 314 84.5 314.895 84.5 316L84.5 330.5L99 330.5C100.105 330.5 101 331.395 101 332.5C101 333.605 100.105 334.5 99 334.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14621_14788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 380,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPlaceholder);
export default __webpack_public_path__ + "static/media/svgPlaceholder.1917eafa682da9237fc9cdda2f0f30c1.svg";
export { ForwardRef as ReactComponent };